import { render, staticRenderFns } from "./DocumentRuleDefine.vue?vue&type=template&id=9aee81b6&scoped=true&"
import script from "./DocumentRuleDefine.vue?vue&type=script&lang=js&"
export * from "./DocumentRuleDefine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aee81b6",
  null
  
)

export default component.exports